module.exports = __webpack_public_path__ + "img/home_icon_251286.81aef032.png";